<script setup lang="ts">
import SvgIcon from "@/components/svg-icon.vue";
import { userStore } from "@/store";
import { computed, ref } from "vue";
import defaultAvatar from '../svg/svg-avatar.svg';

const visible = ref(false);

const _userStore = userStore();

/** 展开 */
const show = () => {
  visible.value = true;
};

const baseInfo = computed(() => {
  const info = _userStore.userInfo;
  const list = [
    {
      title: "姓名",
      value: info.userName,
    },
    {
      title: "所属门店",
      value: info.shopName,
    },
    {
      title: "员工身份",
      value: info.roles?.[0]?.roleName,
    },
    {
      title: "员工职称",
      value: info.consultantRankName,
    },
    {
      title: "手机号吗",
      value: info.phonenumber,
    },
    {
      title: "邮箱",
      value: info.email,
    },
    {
      title: "员工花名",
      value: info.nickName,
    },
    {
      title: "员工工号",
      value: info.employeeNumber,
    },
    {
      title: "员工微信号",
      value: info.wxAccount,
    },
    {
      title: "员工身份证",
      value: info.idCard,
    },
  ]
  return list.map(x => ({ ...x, value: x.value || '--' }))
});

/** 更多信息 */
const othersInfo = computed(() => {
  const info = _userStore.userInfo;
  const list = [
    {
      title: '个人技能',
      value : info.skill,
    },
    {
      title: '现居住地',
      value : info.address,
    },
    {
      title: '紧急联系人',
      value : info.importantContact,
    },
    {
      title: '紧急联系人电话',
      value : info.importantPhone,
    },
    {
      title: '个人描述',
      value : info.remark,
    },
    {
      title: '员工作品集',
      value : info.galleries,
    },
  ]
  return list.map(x => ({ ...x, value: x.value || '--' }))
})

defineExpose({
  show,
});
</script>

<template>
  <el-drawer v-model="visible" :with-header="false" :append-to-body="true">
    <div class="pb-5 flex items-center justify-between">
      <h6 class="font-bold text-base">员工中心</h6>
      <el-button @click="visible = false" text>
        <SvgIcon iconName="icon-close" />
      </el-button>
    </div>

    <el-divider class="absolute left-0 right-0 my-0" />

    <div class="flex relative py-5 mt-[1px]">
      <div
        class="bg-[#F7F9FB] absolute left-[-20px] right-[-20px] bottom-0 top-0 z-0"
      ></div>

      <div class="flex-1 grid z-10 leading-5 grid-cols-[60px_auto] mr-4">
        <img
          class="size-[54px] col-[1_/_2] row-[1_/_4] rounded-full"
          :src="_userStore.userInfo.avatar || defaultAvatar"
          alt="avatar"
        />
        <div class="flex text-[14px] items-center col-[2_/_3] row-[1_/_2]">
          <span class="text-[#333333]">{{ _userStore.userInfo.userName }}</span>
          <SvgIcon
            :iconName="
              _userStore.userInfo.sex === '0' ? 'icon-woman' : 'icon-man'
            "
            class="ml-1"
            :size="18"
          />
        </div>
        <p class="text-[#666666] text-[10px]">
          {{ _userStore.userInfo.idCard }}
        </p>
        <p class="text-[#666666] text-[10px]">
          工号：{{ _userStore.userInfo.employeeNumber }}
        </p>
      </div>

      <div class="z-10 leading-5 text-[10px]">
        <p>
          <span class="text-[#666666]">门店：</span>
          {{ _userStore.userInfo.shopName }}
        </p>
        <p>
          <span class="text-[#666666]">身份：</span>
          {{ _userStore.userInfo.roles?.[0]?.roleName }}
        </p>
        <p>
          <span class="text-[#666666]">职称：</span>
          {{ _userStore.userInfo.consultantRankName }}
        </p>
      </div>
    </div>

    <el-collapse :model-value="['baseInfo', 'others']" class="info_collapse">
      <el-collapse-item class="mt-5" name="baseInfo" title="基本信息">
        <el-row class="border border-[#dedede] pt-5 px-[10px] m-0"  :gutter="20">
          <el-col v-for="item in baseInfo" :span="12" class="mb-5">
            <p class=" border-b border-[#D8D8D8] h-full">{{ `${item.title}：${item.value}` }}</p>
          </el-col>
        </el-row>
      </el-collapse-item>

      <el-collapse-item class="mt-5" name="others" title="更多">
        <el-row class="border border-[#dedede] pt-5 px-[10px] m-0"  :gutter="20">
          <el-col v-for="item in othersInfo" :span="24" class="mb-5">
            <p class=" border-b border-[#D8D8D8] h-full">{{ `${item.title}：${item.value}` }}</p>
          </el-col>
        </el-row>
      </el-collapse-item>
    </el-collapse>
  </el-drawer>
</template>

<style lang="scss" scoped>
.info_collapse {
  --el-collapse-border-color: transparent;
  --el-collapse-header-font-size: 16px;
}
</style>
